import { Button, Col, Form, Input, Row, Select, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import { countryList } from '../../data/countryList';

const { Option } = Select;
const { Text } = Typography;

function LearnerForm(props) {
  const { initialValues, onSubmit, status, type } = props;

  const countryNames = countryList.map((country) => country.name);
  const countryListMenu = countryList.map((country) => (
    <Option value={country.id}>{country.name}</Option>
  ));

  const [form] = Form.useForm();

  const laptopListMenu = [
    {
      value: 'mac',
      name: 'Macbook',
    },
    {
      value: 'windows',
      name: 'Windows',
    },
    {
      value: 'linux',
      name: 'Linux',
    },
    {
      value: 'others',
      name: 'Others',
    },
  ].map((option) => <Option value={option.value}>{option.name}</Option>);

  const editingSoftwareListMenu = [
    {
      value: 'fcp',
      name: 'Final Cut Pro',
    },
    {
      value: 'pp',
      name: 'Premiere Pro',
    },
  ].map((option) => <Option value={option.value}>{option.name}</Option>);

  const cameraListMenu = [
    {
      value: 'dslr',
      name: 'DSLR',
    },
    {
      value: 'phone',
      name: 'Phone camera',
    },
    {
      value: 'others',
      name: 'Others',
    },
  ].map((option) => <Option value={option.value}>{option.name}</Option>);

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues]);

  return (
    <Form
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 14 }}
      onFinish={onSubmit}
      initialValues={initialValues}
      form={form}
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { type: 'email', required: true, message: 'Please input Email!' },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="First Name"
        name="firstName"
        rules={[{ required: true, message: 'Please input unit First Name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Last Name"
        name="lastName"
        rules={[{ required: true, message: 'Please input unit Last Name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item label="Phone Number" name="phoneNumber">
        <Input />
      </Form.Item>
      <Form.Item
        label="Country"
        name="countryId"
        rules={[{ required: true, message: 'Please select Country!' }]}
      >
        <Select
          placeholder="Select a country"
          showSearch
          onSearch={null}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {countryListMenu}
        </Select>
      </Form.Item>
      <Form.Item label="Profile Image" name="profileImage">
        <Input />
      </Form.Item>
      <Form.Item label="Description" name="description">
        <Input />
      </Form.Item>
      <Form.Item
        label="Street name"
        name="address"
        rules={[{ required: false, message: 'Please input street name' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Unit/block"
        name="additionalAddress"
        rules={[{ required: false, message: 'Please input unit/block' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="City"
        name="city"
        rules={[{ required: false, message: 'Please input city' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Postal code"
        name="postalCode"
        rules={[{ required: false, message: 'Please input postal code' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Laptop type"
        name="laptop"
        rules={[{ required: false, message: 'Please select laptop type!' }]}
      >
        <Select placeholder="Select a type">{laptopListMenu}</Select>
      </Form.Item>
      <Form.Item
        label="Editing software type"
        name="editingSoftware"
        rules={[
          { required: false, message: 'Please select editing software type!' },
        ]}
      >
        <Select placeholder="Select a type">{editingSoftwareListMenu}</Select>
      </Form.Item>
      <Form.Item
        label="Camera type"
        name="camera"
        rules={[{ required: false, message: 'Please select camera type!' }]}
      >
        <Select placeholder="Select a type">{cameraListMenu}</Select>
      </Form.Item>
      {status.type === 'ERROR' ? (
        <Text type="danger">{status.message}</Text>
      ) : null}
      {status.type === 'SUCCESS' ? (
        <Text type="success">Sucessfully Updated!</Text>
      ) : null}
      <Row justify="end" gutter={12}>
        <Col>
          <Button type="primary" htmlType="submit">
            {type}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default LearnerForm;
